import { render, staticRenderFns } from "./DoctorSelect.vue?vue&type=template&id=d1520e6e&"
import script from "./DoctorSelect.vue?vue&type=script&lang=js&"
export * from "./DoctorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports